import { useObservable } from "@faire/web/ui/hooks/useObservable";

import { useLoggedOutCategoryPageViewStateContext } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/LoggedOutCategoryPageViewState/useLoggedOutCategoryPageViewState";

export const useLoggedOutCategoryPageCatNavResponse = () => {
  const viewState = useLoggedOutCategoryPageViewStateContext();
  const data = {
    productFirstSearchResults: useObservable(
      () => viewState.productFirstSearchResults
    ),
    requestId: useObservable(() => viewState.requestId),
    paginationData: useObservable(() => viewState.paginationData),
    pageCount: useObservable(() => viewState.pageCount),
    brandPageQueryParams: useObservable(() => viewState.brandPageQueryParams),
    totalPrimaryResultsCount: useObservable(
      () => viewState.totalPrimaryResultsCount
    ),
    relatedSearchTerms: useObservable(() => viewState.relatedSearchTerms),
    moreInC3CategoryName: useObservable(() => viewState.moreInC3CategoryName),
    moreInC3Terms: useObservable(() => viewState.moreInC3Terms),
    dataUpdatedAt: useObservable(() => viewState.dataUpdatedAt),
  };
  return {
    data,
    error: useObservable(() => viewState.error),
    isFetching: useObservable(() => viewState.loading),
  };
};
